var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42633 20.7109L10.5333 12.5929C11.0909 12.0325 11.4039 11.274 11.4039 10.4834C11.4039 9.69285 11.0909 8.93441 10.5333 8.37394L2.41733 0.245937L0.611328 2.05394L8.72633 10.1809C8.80547 10.2607 8.84988 10.3686 8.84988 10.4809C8.84988 10.5933 8.80547 10.7011 8.72633 10.7809L0.620328 18.9019L2.42633 20.7109Z",
    fill: "#F9FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/sliderArrow.7e9eb7103cda90590bdab6d09c32c3a3.svg";
export { ForwardRef as ReactComponent };